export default () => {
  return {
    labelRoot: {
      alignItems: 'flex-start',
      marginLeft: 0,
    },

    checkboxRoot: {
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    checkboxChecked: {
      '&&:hover': {
        backgroundColor: 'transparent',
      },
    },
  }
}
